import React from 'react';

import {RunRenameScope} from '../types';
import {RunRowHeaderMenu} from './RunRowHeaderMenu';

const spacer = (
  <div style={{height: 16, width: 16, flexGrow: 0, flexShrink: 0}} />
);

type RowHeaderMenuProps = {
  canBenchmarkRun: boolean;
  canStopRun: boolean;
  isHeaderDropdownEmpty: boolean;
  isGroup: boolean;
  onBenchmarkRun: () => void;
  onDeleteRun: () => void;
  onMoveRun: () => void;
  onRenameRow: (scope: RunRenameScope) => void;
  onStopRun: () => void;
};

export function RowHeaderMenu({
  canBenchmarkRun,
  canStopRun,
  isHeaderDropdownEmpty,
  isGroup,
  onBenchmarkRun,
  onDeleteRun,
  onMoveRun,
  onRenameRow,
  onStopRun,
}: RowHeaderMenuProps) {
  if (isHeaderDropdownEmpty) {
    return spacer;
  }
  if (!isGroup) {
    return (
      <RunRowHeaderMenu
        onBenchmarkRun={onBenchmarkRun}
        onDeleteRun={onDeleteRun}
        onMoveRun={onMoveRun}
        onRenameRun={onRenameRow}
        onStopRun={onStopRun}
        canBenchmarkRun={canBenchmarkRun}
        canStopRun={canStopRun}
      />
    );
  }

  return spacer;
}
